import isNil from 'lodash/isNil';

const STATIC_PROPS = {
  type: 'hidden',
};

// adding testId to the input instead of ace-editor itself
// ace-editor does not support arbitrary data-* attrs via props or editorProps
function buildTestId(testId) {
  if (isNil(testId)) {
    return;
  }

  return {
    'data-test-id': testId,
  };
}

export default function buildHiddenInputProps({ id, name, value, testId }) {
  return {
    ...STATIC_PROPS,
    ...buildTestId(testId),
    id,
    name,
    value,
  };
}
